import { ModificationDto } from "app/ApiClient";
import { LoadingState } from "types";

export type ModificationsState = {
  creatingState: LoadingState;
  creatingError?: string | null;
  modifications: ModificationDto[];
  createdModification?: ModificationDto;
  respondantDateRange: Array<Date>;
};

export const initialModificationsState: ModificationsState = {
  creatingState: LoadingState.idle,
  creatingError: null,
  modifications: [],
  respondantDateRange: [],
};
